module.exports = __webpack_public_path__ + "img/hxh.41cba9a6.png";